import React, { useState } from "react";
import Label from "./Common/Label";
import { Link } from "react-router-dom";
import RowContainer from "./Common/RowContainer";
import Container from "./Common/Container";
import HorizontalSpace from "./HorizontalSpace";
import editIcon from "../assets/editIcon.svg";
import deleteIcon from "../assets/deleteIcon.svg";
import CustomCheckbox from "./Common/CustomCheckbox";
import Switch from "./Common/Switch";
import styled from "styled-components";

const PLAN_OPTIONS = [
  { label: "--", value: "" },
  { label: "Mensual", value: "mensual" },
  { label: "Trimestral", value: "trimestral" },
  { label: "Semestral", value: "semestral" },
  { label: "Anual", value: "anual" },
];

interface Member {
  id: number;
  srNo: number;
  name: string;
  lastname: string;
  email: string;
  created: string;
  onEdit: (id: number) => void;
  status: boolean;
  onCheckboxChange: (id: number) => void;
  isChecked: boolean;
  onDelete: (id: number) => void;
  onStatusChange: (id: number) => void;
  onUpgradePlan?: (id: number, planType: string) => void;
}

const NewRowContainer = styled(RowContainer)`
  overflow: hidden;
`;

const NewLabel = styled(Label)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const MembersUser: React.FC<Member> = ({
  id,
  srNo,
  name,
  lastname,
  email,
  created,
  onDelete,
  onEdit,
  status,
  onCheckboxChange,
  isChecked,
  onStatusChange,
  onUpgradePlan,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(status);
  const [selectedPlan, setSelectedPlan] = useState("");

  const toggleSwitch = () => {
    const newStatus = !isSwitchOn;
    setIsSwitchOn(newStatus);
    onStatusChange(id);
  };

  const handleDelete = () => {
    onDelete(id);
  };

  const handlePlanChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const plan = e.target.value;
    if (plan && onUpgradePlan) {
      setSelectedPlan(plan);
      onUpgradePlan(id, plan);
    }
  };

  return (
    <Container
      bgColor="#fff"
      borderRadius="10px"
      height="50px"
      alignItems="center"
      display="flex"
      width="100%"
      className="user-data user-container-hover"
    >
      <RowContainer
        justifyContent="space-between"
        alignItem="center"
        borderRadius="12px"
        margin="10px"
        className=""
      >
        <RowContainer flex="1.5">
          {/* <CustomCheckbox
            checked={isChecked}
            onChange={() => onCheckboxChange(id)}
          /> */}
        </RowContainer>
        <NewRowContainer flex="2" gap="0px">
          <NewLabel fontWeight={400} fontSize="16px" color="#201F29">
            {srNo}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="5" gap="0px">
          <NewLabel fontWeight={400} fontSize="16px">
            {name}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="5" gap="0px">
          <NewLabel fontWeight={400} fontSize="16px">
            {lastname}
          </NewLabel>
        </NewRowContainer>
        <NewRowContainer flex="8" gap="0px">
          <NewLabel fontWeight={400} fontSize="16px">
            {email}
          </NewLabel>
        </NewRowContainer>

        <NewRowContainer flex="6">
          <NewLabel fontWeight={400} fontSize="16px">
            {created}
          </NewLabel>
        </NewRowContainer>
        <RowContainer flex="4">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ gap: "10px" }}
          >
            {onUpgradePlan && (
              <select
                value={selectedPlan}
                onChange={handlePlanChange}
                style={{
                  height: "36px",
                  borderRadius: "8px",
                  border: "1px solid #D0D0D0",
                  backgroundColor: "#F8F8F8",
                  fontSize: "13px",
                  color: "#201F29",
                  padding: "0 8px",
                  cursor: "pointer",
                  outline: "none",
                  minWidth: "110px",
                }}
              >
                {PLAN_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            )}
            <Switch isOn={isSwitchOn} onToggle={toggleSwitch} />
            <div style={{ cursor: "pointer" }}>
              <img
                src={editIcon}
                className="user-scale"
                onClick={() => onEdit(id)}
                style={{ WebkitUserSelect: "none", userSelect: "none" }}
              />
            </div>
            {/* <div style={{ cursor: "pointer" }} onClick={handleDelete}>
              <img src={deleteIcon} style={{ WebkitUserSelect: "none", userSelect: "none" }}/>
            </div> */}
          </div>
        </RowContainer>
      </RowContainer>
    </Container>
  );
};
export default MembersUser;
